<template>
  <div
    class="inbox--name gap-0.5 inline-flex items-center px-0 leading-3 font-medium bg-none my-0"
  >
    <img
      v-if="inboxBadgeIcon"
      :src="inboxBadgeIcon"
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0 w-[10px] h-[10px]"
    />
    <fluent-icon
      v-else
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0"
      :icon="computedInboxClass"
      size="10"
    />
    <span class="text-gray-500" :class="textSize">
      {{ isInboxNameMode ? inbox.name : currentContact.email }}
    </span>
  </div>
</template>
<script>
import { getInboxClassByType } from 'dashboard/helper/inbox';
import { INBOX_TYPES, INBOX_NAME_MODES } from 'shared/mixins/inboxMixin';

import websiteBadge from 'dashboard/assets/images/inbox_icons/website-badge-nocolor.svg';
import whatsappBadge from 'dashboard/assets/images/inbox_icons/whatsapp-badge-nocolor.svg';
import messengerBadge from 'dashboard/assets/images/inbox_icons/messenger-badge-nocolor.svg';
import facebookBadge from 'dashboard/assets/images/inbox_icons/facebook-badge-nocolor.svg';
import telegramBadge from 'dashboard/assets/images/inbox_icons/telegram-badge-nocolor.svg';
import lineBadge from 'dashboard/assets/images/inbox_icons/line-badge-nocolor.svg';
import tiktokBadge from 'dashboard/assets/images/inbox_icons/tiktok-badge-nocolor.svg';
import gmailBadge from 'dashboard/assets/images/inbox_icons/gmail-badge-nocolor.svg';
import microsoftBadge from 'dashboard/assets/images/inbox_icons/microsoft-badge-nocolor.svg';

const INBOX_BADGE_ICONS = {
  [INBOX_TYPES.WEB]: websiteBadge,
  [INBOX_TYPES.WHATSAPP]: whatsappBadge,
  [INBOX_TYPES.FB]: messengerBadge,
  [INBOX_TYPES.FB2]: facebookBadge,
  [INBOX_TYPES.TELEGRAM]: telegramBadge,
  [INBOX_TYPES.LINE]: lineBadge,
  [INBOX_TYPES.TIKTOK]: tiktokBadge,
  'Channel::Api_wa_v1': whatsappBadge,
  'Channel::Api_wa_v2': whatsappBadge,
  'Channel::Api_wa_v3': whatsappBadge,
  'Channel::Email_gmail': gmailBadge,
  'Channel::Email_microsoft_api': microsoftBadge,
};

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
    textSize: {
      type: String,
      default: () => 'text-xxs/[18px]',
    },
    mode: {
      type: String,
      default: INBOX_NAME_MODES.INBOX_NAME,
    },
    currentContact: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    resolvedType() {
      let {
        phone_number: phoneNumber,
        channel_type: type,
        api_type: apiType,
      } = this.inbox;
      if (apiType) type = `${type}_${apiType}`; // d99d todo refactoring - copypast
      return { type, phoneNumber };
    },
    inboxBadgeIcon() {
      const { type, phoneNumber } = this.resolvedType;
      if (type === INBOX_TYPES.TWILIO && phoneNumber?.startsWith('whatsapp')) {
        return whatsappBadge;
      }
      return INBOX_BADGE_ICONS[type] || null;
    },
    computedInboxClass() {
      const { type, phoneNumber } = this.resolvedType;
      return getInboxClassByType(type, phoneNumber);
    },
    isInboxNameMode() {
      return this.mode === INBOX_NAME_MODES.INBOX_NAME;
    },
  },
};
</script>
